import React, { Component } from "react";
import InfoBoardRow from "./InfoBoardRow";
import articlesCalc from "../services/articlesCalcService";

export default class CostEstimateRow extends Component {
    editables = ["extra_cost", "quantity"];

    visibleColumns = [
        "article_number",
        "name",
        "quantity",
        "unit",
        "width",
        "height",
        "laps",
        "_weightWithThreeDecimals",
        "_time",
        "extra_cost",
        "_production_cost",
        "_purchase_price",
        "_margin",
        "_price",
        "_discount",
        "_price_after_discount"
    ];

    infoboard6Editables = {
        'name':                     {'translateAs': 'name', 'type': 'text', 'defaultValue': ''},
        '_weightWithThreeDecimals': {'translateAs': 'weight', 'type': 'number', 'defaultValue': 0},
        '_time':                    {'translateAs': 'production_time', 'type': 'text', 'defaultValue': '00:00:00'},
        '_production_cost':         {'translateAs': 'production_cost', 'type': 'number', 'defaultValue': 0},
        '_purchase_price':          {'translateAs': 'purchase_price', 'type': 'number', 'defaultValue': 0}
    };

    getColumn = function (name, index) {
        let className = "listCell p-2";
        let content = "";
        const doCalc = name[0] === "_";
        const { data, onChange, sortIndex, tableHeadings } = this.props;

        if (data.infoboard_id == 6 && this.infoboard6Editables.hasOwnProperty(name)) {

            const thisField = this.infoboard6Editables[name];
            const useName = thisField.translateAs;
            if (typeof data[useName] == 'undefined') {
                data[useName] = thisField.defaultValue;
            }

            if (this.props.isEditable) {
                const nameAttr =
                    data.parentIndex !== null
                        ? `rows[${data.parentIndex}][${sortIndex}][${useName}]`
                        : `rows[${sortIndex}][${useName}]`;

                if (thisField.type === 'text') {
                    
                    let titleText = '';

                    if (useName === 'production_time') {
                        titleText = 'Ange produktionstid per enhet';
                    }

                    content = (
                        <input
                            className="form-control cost-estimate-form-field"
                            data-attribute-name={useName}
                            name={nameAttr}
                            title={titleText}
                            onChange={event =>
                                onChange(
                                    data.id,
                                    event.target.getAttribute(
                                        "data-attribute-name"
                                    ),
                                    event.target.value,
                                    "row_outside_of_infoboard"
                                )
                            }
                            readOnly={data.parentIndex !== null}
                            value={data[useName]}
                        />
                    );
                } else if (thisField.type === 'number') {

                    let titleText = '';

                    if (useName === 'production_cost') {
                        titleText = 'Ange produktionskostnad per enhet';
                    } else if (useName === 'purchase_price') {
                        titleText = 'Ange inköpspris per enhet';
                    } else if (useName === 'weight') {
                        titleText = 'Ange vikt per enhet';
                    }

                    content = (
                        <input
                            className="form-control cost-estimate-form-field"
                            data-attribute-name={useName}
                            min={0}
                            name={nameAttr}
                            title={titleText}
                            onChange={event =>
                                onChange(
                                    data.id,
                                    event.target.getAttribute(
                                        "data-attribute-name"
                                    ),
                                    event.target.value,
                                    "row_outside_of_infoboard"
                                )
                            }
                            readOnly={data.parentIndex !== null}
                            step="0.0001"
                            type="number"
                            value={data[useName]}
                        />
                    );
                }
            } else {
                content = data[useName];
            }
        }
        else if (doCalc) {
            content = this.calc.get(name.substr(1));
        } else if ("article_number" === name && data.infoboard_id > 0 && data.infoboard_id != 6) {
            content = (
                <React.Fragment>
                    <button
                        className={
                            "btn btn-primary btn-toggle mb-1 mr-1 btn-no-box-shadow" +
                            (data.showInfoBoard ? " is-toggled" : "")
                        }
                        onClick={event => this.handleToggleInfoBoard(event)}
                    >
                        <i className="icon" />
                    </button>
                    <span>{data[name]}</span>
                </React.Fragment>
            );
        } else {
            if (this.isEditableInput(name)) {
                const nameAttr =
                    data.parentIndex !== null
                        ? `rows[${data.parentIndex}][${sortIndex}][${name}]`
                        : `rows[${sortIndex}][${name}]`;

                const minValue = name == 'extra_cost' ? -9999999 : 0;
                content = (
                    <input
                        className="form-control cost-estimate-form-field"
                        data-attribute-name={name}
                        min={minValue}
                        name={nameAttr}
                        onChange={event =>
                            onChange(
                                data.id,
                                event.target.getAttribute(
                                    "data-attribute-name"
                                ),
                                event.target.value,
                                "row_outside_of_infoboard"
                            )
                        }
                        readOnly={data.parentIndex !== null}
                        step="0.0001"
                        type="number"
                        value={data[name]}
                    />
                );
            } else {
                if ("article_number" == name) {
                    if (parseInt(data["is_single"])) {
                        content = (
                            <span
                                title="Artikeln beräknas bara en gång oavsett prisintervallets antal"
                                className="bold"
                            >
                                {data["article_number"]}
                            </span>
                        );
                    } else {
                        content = data["article_number"];
                    }
                } else if ("name" === name) {
                    let stockWarningMessage = data["in_stock"] == 0 ? " (beställningsvara)" : "";

                    let formattedName =
                        data[name].length > 55
                            ? data[name].substr(0, 55)
                            : data[name];

                    if (stockWarningMessage != "" && data[name].length > 55) {
                        formattedName = formattedName.substr(0, 55 - ("(beställningsvara)".length));
                    }

                    content = <React.Fragment><span title={data[name]}>{formattedName}</span><span className="stockWarning">{stockWarningMessage}</span></React.Fragment>
                } else {
                    content = data[name];
                }
            }
        }

        if (typeof parseFloat(content) === 'number') {
            className += " text-" + this.props.tableHeadings[index].align;
        }

        return (
            <div
                className={className}
                key={name}
                style={tableHeadings[index].styles}
            >
                {content}
            </div>
        );
    };

    handleToggleInfoBoard(event) {
        const { data, onChange } = this.props;

        event.preventDefault();

        onChange(data.id, "showInfoBoard", !data.showInfoBoard);
    }

    isEditableInput = name =>
        this.props.isEditable &&
        //this.props.data.parentIndex === null &&
        this.editables.indexOf(name) >= 0;

    constructor(props) {
        super(props);
        this.calc = new articlesCalc();
    }

    render() {
        let {
            customer,
            data,
            globalSettings,
            dragHandler,
            isEditable,
            onChange,
            onDelete,
            sortIndex
        } = this.props;
        const articleNumberAttr =
            data.parentIndex !== null
                ? `rows[${data.parentIndex}][${sortIndex}][article_number]`
                : `rows[${sortIndex}][article_number]`;
        const idAttr =
            data.parentIndex !== null
                ? `rows[${data.parentIndex}][${sortIndex}][id]`
                : `rows[${sortIndex}][id]`;
        const dontRecalculateQuantityAttr =
            data.parentIndex !== null
                ? `rows[${
                data.parentIndex
                }][${sortIndex}][dont_recalculate_quantity]`
                : `rows[${sortIndex}][dont_recalculate_quantity]`;

        const infoBoardData = {};

        data.customer = customer;
        data.global_settings = globalSettings;

        this.calc.setData(data);
 
        if (data.infoboard_id > 0) {
            infoBoardData.id = data.infoboard_id;
            infoBoardData.name = data.infoboard_name;
            infoBoardData.data = data;
            infoBoardData.extendedData = data.infoboarddata
                ? JSON.parse(data.infoboarddata)
                : {};
            infoBoardData.globalSettings = globalSettings;
            infoBoardData.sortIndex = sortIndex;
            infoBoardData.showInfoBoard = data.showInfoBoard;
        }

        let sectionClasses = "listRowContainer";

        if (data.deleted_at) {
            sectionClasses += " deleted";
        }

        if (data.active == 0) {
            sectionClasses += " inactive";
        }

        if (data.role == 3) {
            sectionClasses += " standalone";
        }

        return (
            <section className={sectionClasses}>
                <div className="listRow">
                    {this.visibleColumns.map((column, index) =>
                        this.getColumn(column, index)
                    )}
                    {isEditable && (
                        <div className="listCell actions">
                            <input
                                type="hidden"
                                name={articleNumberAttr}
                                value={data.article_number}
                                readOnly
                            />
                            {data.id && (
                                <input
                                    type="hidden"
                                    name={idAttr}
                                    value={data.id}
                                    readOnly
                                />
                            )}
                            <button
                                onClick={event => onDelete(data, event)}
                                className="btn btn-icon btn-icon--noText btn-icon--deleteInverted"
                            />
                            {dragHandler}
                        </div>
                    )}
                    <div className="listCell p-2 text-left d-none">
                        <input
                            type="hidden"
                            name={dontRecalculateQuantityAttr}
                            value={data.dont_recalculate_quantity || 0}
                            readOnly
                        />
                    </div>
                </div>
                {infoBoardData.id && (
                    <InfoBoardRow
                        {...infoBoardData}
                        isEditable={isEditable}
                        onChange={onChange}
                    />
                )}
            </section>
        );
    }
}